/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowCraftWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowCraftWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Get Crafty!",
    "Craft Workshop Awaits!",
    "Create and Craft Together!",
  ],
  title: "Craft Workshop",
  description: "Organize a fun and creative craft workshop.",
  longDescription:
    "Gather your friends for a creative craft workshop! Choose a date, decide on crafts to work on, and plan the materials needed!",
  emoji: "✂",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Craft Workshop",
          emoji: "✂",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the craft workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on crafts to work on?",
            description: "What crafts should we focus on during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What crafts should we consider?",
                emoji: "🎨",
                completeAction: {
                  question: "Decide on materials needed?",
                  description: "What materials should we gather for crafting?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What materials should we bring?",
                      emoji: "🧶",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Crafty!",
    outroDescription:
      "Your craft workshop plans are set! Enjoy the creativity!",
  },
};
